<template>
  <div
    @click.stop="clickCollapsable(section, index)"
    :class="`summary-section-title ${section.collapsable ?
      'collapsable' : ''} ${!section.toggleCollapse ? 'closed' : ''}`"
  >
    {{ section.title.replaceAll(';', ',') }}

    <template v-if="section.collapsable">
      <div
        class="end"
      >
        <Chevron
          :direction="!section.toggleCollapse ? 'bottom' : ''"
        />
      </div>
    </template>
  </div>
</template>

<script>
import Chevron from './Chevron.vue';

export default {
  components: {
    Chevron,
  },
  props: {
    section: Object,
    index: Number,
  },
  methods: {
    clickCollapsable() {
      this.$emit('clickCollapsable', this.section, this.index);
    },
  },
};
</script>

<style lang="scss" scoped>
   .summary-section-title {
      background-color: $surface-light;
      font-size: 14px;
      font-weight: bold;
      text-transform: uppercase;
      padding: 16px;

      &.collapsable {
        display: flex;
        gap: 5px;
        margin: 10px 0 5px 0;
      }

     &.closed {
        margin-bottom: 10px;
      }

    .end {
      margin-left: auto;
    }
  }
</style>
